import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { SolicitacaoService } from 'app/service/solicitacao/solicitacao.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

interface OrganizeContainer {
  id: number;
  id1: number;
  id2: number;
  id3: number;
  valor: string;
  solicitacaoId: number;
}

@Component({
  selector: 'app-configurar-container',
  templateUrl: './configurar-container.component.html',
  styleUrls: ['./configurar-container.component.scss']
})
export class ConfigurarContainerComponent implements OnInit {
  loading = false;
  numeros: any[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<OrganizeContainer>([]);
  dataSourceContainer = new MatTableDataSource<OrganizeContainer>([]);
  displayedColumns: string[] = ['select', 'numero'];
  displayedColumnsContainer: string[] = ['select', 'container'];
  selection = new SelectionModel<any>(true, []);
  selectedRows: any[] = [];
  selectedRowsContainer: any[] = [];
  savedSelections: any[] = [];
  allSelectedRows: any[] = []; // Para armazenar todas as seleções salvas
  qtdSelected;
  containersDoneArray: OrganizeContainer[] = [];
  numeracaoInContainerObject: OrganizeContainer[] = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef <ConfigurarContainerComponent>,
    private solicitacaoService: SolicitacaoService,
    private _snackBar: MatSnackBar
  ) {
    this.numeros = this.data.numeros;
    // this.numeros.forEach(el => {
    //   this.numeracaoInContainerObject.push({
    //     id: null,
    //     id1: el.id,
    //     id2: null,
    //     id3: null,
    //     valor: el.valor,
    //     solicitacaoId: this.data.solicitacaoId
    //   });
    // });
    this.qtdSelected = this.data.qtd;
   }

  ngOnInit() {
    this.dataSourceContainer = new MatTableDataSource(this.numeros);
  }

  criarNovosArrays(arrayOriginal, parametro) {
    const novoArray = [];
  
    for (let i = 0; i < arrayOriginal.length; i += parametro) {
      const grupoElementos = [];
      for (let j = i; j < i + parametro; j++) {
        if (j < arrayOriginal.length) {
          grupoElementos.push(arrayOriginal[j]);
        }
      }
  
      if (grupoElementos.length === parametro) {
        const novoObjeto = {
          id: grupoElementos[0].id,
          valor: grupoElementos.map(elemento => elemento.valor).join("-")
        };
  
        for (let j = 1; j < parametro; j++) {
          novoObjeto[`id${j + 1}`] = grupoElementos[j].id;
        }
  
        novoArray.push(novoObjeto);
      } else if (grupoElementos.length >= 1) {
        const novoObjeto = {
          id: grupoElementos[0].id,
          valor: grupoElementos.map(elemento => elemento.valor).join("-")
        };
        novoArray.push(novoObjeto);
      }
    }
  
    return novoArray;
  }

  toggleRow(row: any, event: any): void {
    console.log(row);
    console.log(event);
    if (event.checked) {
      if (this.qtdSelected === 2 && this.selectedRows.length < 2) {
        this.selectedRows.push(row);
      } else if (this.qtdSelected === 3 && this.selectedRows.length < 3) {
        this.selectedRows.push(row);
      } else {
        event.source.checked = false;
      }
    } 
    else {
      // Impedir desmarcar se já estiver selecionado
      event.source.checked = true;
    }
  }

  toggleRowContainer(row: any, event: any): void {
    console.log(row);
    console.log(event);
    if (event.checked) {
      this.selectedRowsContainer.push(row);
    } 
  }

  isCheckboxDisabled(row: any): boolean {
    if (this.qtdSelected === 1) {
      return true;
    } else if (this.qtdSelected === 2 && this.selectedRows.length >= 2 && !this.selectedRows.includes(row)) {
      return true;
    } else if (this.qtdSelected === 3 && this.selectedRows.length >= 3 && !this.selectedRows.includes(row)) {
      return true;
    } else if (this.allSelectedRows.includes(row)) {
      return true;
    }
    return false;
  }

  isRowSelected(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  saveSelection(): void {
    this.savedSelections.push([...this.selectedRows]);
    this.allSelectedRows.push(...this.selectedRows);
    // Adicione lógica adicional aqui, se necessário
    console.log(this.savedSelections);

    
    this.containersDoneArray.push(
      {
        id: null,
        id1: this.selectedRows[0].id1,
        id2: this.selectedRows.length >= 2 ? this.selectedRows[1].id1 : null,
        id3: this.selectedRows.length >= 3 ? this.selectedRows[2].id1 : null,
        valor: this.createValorToSend(),
        solicitacaoId: this.data.solicitacaoId
      }
    );
    
    console.log(this.containersDoneArray);
    let dadosContainerTable = this.dataSourceContainer.data;
    dadosContainerTable.push(...this.containersDoneArray);
    this.dataSourceContainer = new MatTableDataSource(dadosContainerTable);
    this.containersDoneArray = [];
    console.log(this.dataSourceContainer.data);

    this.dataSource.data = this.dataSource.data.filter(row => !this.selectedRows.includes(row));
    this.selection.clear();
    this.selectedRows = [];
  }

  removeFromContainer() {
    let arrayToBack: OrganizeContainer[] = [];
    this.selectedRowsContainer.forEach(el => {
      arrayToBack.push(...this.createArrayToBack(el));
    });

    let dataAtual = this.dataSource.data;
    dataAtual.push(...arrayToBack)
    this.dataSource = new MatTableDataSource(dataAtual);

    this.dataSourceContainer.data = this.dataSourceContainer.data.filter(row => !this.selectedRowsContainer.includes(row));

    console.log(this.dataSource.data);
    console.log(this.dataSourceContainer.data);
    this.selectedRowsContainer = [];
  }

  createArrayToBack(rowSelected: any): OrganizeContainer[] {
    if (this.qtdSelected === 2) {
        return [
          {
            id: null,
            id1: rowSelected.id1,
            id2: null,
            id3: null,
            valor: rowSelected.valor.split('-')[0],
            solicitacaoId: rowSelected.solicitacaoId
          },
          {
            id: null,
            id1: rowSelected.id2,
            id2: null,
            id3: null,
            valor: rowSelected.valor.split('-')[1],
            solicitacaoId: rowSelected.solicitacaoId
          }
        ];
    }
    if (this.qtdSelected === 3) {
      return [
        {
          id: null,
          id1: rowSelected.id1,
          id2: null,
          id3: null,
          valor: rowSelected.valor.split('-')[0],
          solicitacaoId: rowSelected.solicitacaoId
        },
        {
          id: null,
          id1: rowSelected.id2,
          id2: null,
          id3: null,
          valor: rowSelected.valor.split('-')[1],
          solicitacaoId: rowSelected.solicitacaoId
        },
        {
          id: null,
          id1: rowSelected.id3,
          id2: null,
          id3: null,
          valor: rowSelected.valor.split('-')[2],
          solicitacaoId: rowSelected.solicitacaoId
        }
      ];
    }
  }

  createValorToSend() {
    let size = this.selectedRows.length;
    if (size === 1) {
      return this.selectedRows[0].valor;
    }
    if (size === 2) {
      return `${this.selectedRows[0].valor}-${this.selectedRows[1].valor}`;
    }
    if (size === 3) {
      return `${this.selectedRows[0].valor}-${this.selectedRows[1].valor}-${this.selectedRows[2].valor}`;
    }
  }

  salvarOrganizacao() {
    if (this.dataSource.data.length > 0) {
      this.openSnackBarError('Existem números que não estão organizados!');
      return;
    }
    let body = {
      organizacaoContainer: this.dataSource.data,
      organizacaoContainerList: this.dataSourceContainer.data
    }
    this.solicitacaoService.salvarOrganizacaoContainer(body, this.data.solicitacaoId).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Organização salva com sucesso.');
      this.dialogRef.close(data.organizacaoContainers);
    }, err => {
      console.error(err);
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/adicionar-solicitacao/configurar-container/configurar-container/configurar-container.component.ts